import { isBrowser } from './device-type';

const callbacks: Array<() => void> = [];
let hasLoaded = false;

export default function(callback: () => void) {
  callbacks.push(callback);
  if (hasLoaded) {
    callback();
  }
}

if (isBrowser()) {
  if (process.env.NODE_ENV !== 'production') {
    // If we're in development (hot) mode we have to wait an arbitrary amount
    // until the styles have loaded
    // Or maybe until this is resolved: https://github.com/webpack/style-loader/issues/83
    setTimeout(() => {
      callbacks.forEach(c => c());
      hasLoaded = true;
    }, 1000);
  } else {
    (requestAnimationFrame || setTimeout)(() => {
      callbacks.forEach(c => c());
      hasLoaded = true;
    });
  }
}
